import { parseJwtHeader } from './parse-jwt'
import jwtVerify from 'jose/jwt/verify'
import parseJwk from 'jose/jwk/parse'
import type { JWK } from 'jose/jwk/parse'

type JWTVerifyOptions = Parameters<typeof jwtVerify>[2]

async function verifyOpenIdToken<T extends Record<string, any> = Record<string, any>>(
  token: string,
  jwks: JWK[] | string,
  jwtVerifyOptions?: JWTVerifyOptions
): Promise<T> {
  // const tokenBody = parseJwt(token)

  if (typeof jwks === 'string') {
    throw Error('not implemented yet')
  }
  const tokenHeader = parseJwtHeader(token)
  const kid = tokenHeader.kid
  const jwk = kid ? jwks.filter((k) => k.kid === kid)[0] : jwks[0]
  if (jwk) {
    const pem = await parseJwk(jwk)
    const { payload, protectedHeader } = await jwtVerify(token, pem, jwtVerifyOptions)
    return payload as unknown as T
  } else {
    throw new Error('No jwk key matched')
  }
}

export default verifyOpenIdToken
